import Swiper from "swiper/bundle";

const [ w, d, mq ] = [ window, document, window.matchMedia('(max-width: 900px)') ];

const init = () => {

  const thumbSlide = new Swiper('.thumb_slide[data-plugin="thumbSlider"]',{
    slidesPerView: 3,
    spaceBetween: 14,
    breakpoints: {
      900: {
        spaceBetween: 20
      }
    }
  });

  const mainSlide = new Swiper('.main_slide[data-plugin="mainSlider"]',{
    loop: true,
    speed: 1200,
    slidesPerView: 1,
    centeredSlides: true,
    autoHeight: true,
    autoplay:{
      delay: 15000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    navigation: {
      nextEl: '.main-next',
      prevEl: '.main-prev'
    },
    thumbs: {
      swiper: thumbSlide,
    },
  });
}

export default function FEATURE () {
  d.addEventListener('DOMContentLoaded', init );
}